import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import { CSSTransition as CSSTransitionBase } from 'react-transition-group';
export var transitionClassNames = function transitionClassNames(block) {
  return {
    appear: "".concat(block, "--appear"),
    appearActive: "".concat(block, "--appearing"),
    enter: "".concat(block, "--enter"),
    enterActive: "".concat(block, "--entering"),
    exit: "".concat(block, "--exit"),
    exitActive: "".concat(block, "--exiting")
  };
};
export var triggerBrowserReflow = function triggerBrowserReflow($$node) {
  $$node.offsetHeight;
};
export var CSSTransition = function CSSTransition(_ref) {
  var block = _ref.block,
      otherProps = _objectWithoutProperties(_ref, ["block"]);

  return React.createElement(CSSTransitionBase, Object.assign({
    classNames: transitionClassNames(block)
  }, otherProps));
};